import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { defineUrlIcon } from '@carnica/graphics';
import { ymPushNavigationItemClick } from "../../../../../shared/analytics";
import { useAppDispatch, useAppSelector } from "../../../../../shared/model";
import { mappedMessangerData } from "../../../../../shared/config";
import { MessengersMenuFlags } from "../../../../../shared/types";
import { selectChatCofig, setChatOpen, setMenuOpen } from "../../../../../entities/settings/model";
var createIcon = function createIcon(src) {
  return defineUrlIcon({
    url: src,
    multiColor: false,
    defaultSize: 24,
    ratio: 1
  });
};
export var useNavMenu = function useNavMenu(items) {
  var dispatch = useAppDispatch();
  var zoneType = useAppSelector(selectChatCofig).authZoneConfig.zoneType;
  var onItemClick = function onItemClick(item) {
    return function () {
      ymPushNavigationItemClick(item, zoneType);
      if ((typeof item === 'string' ? item : item.featureToggle) === MessengersMenuFlags.IS_CHAT_CHAT_ENABLED) {
        dispatch(setMenuOpen(false));
        dispatch(setChatOpen(true));
      }
    };
  };
  return useMemo(function () {
    return (items || []).map(function (item) {
      var toggleName = typeof item === 'string' ? item : item.featureToggle;
      var navItemData = _objectSpread(_objectSpread({}, mappedMessangerData[toggleName] || {}), {}, {
        key: toggleName,
        onClick: onItemClick(item)
      });
      return _objectSpread(_objectSpread({}, navItemData !== null && navItemData !== void 0 ? navItemData : {}), _typeof(item) === 'object' ? {
        label: item.title,
        icon: item.imageUrl ? createIcon(item.imageUrl) : navItemData.icon,
        attributes: {
          title: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 ".concat(item.title),
          href: item.url || '',
          'aria-label': "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 ".concat(item.title)
        }
      } : {});
    });
  }, [items]);
};